import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@material/material.module';

import { BatchOperationSubmitHiringManagerReviewComponent } from './components/batch-operation-submit-hiring-manager-review.component';

const components = [
  BatchOperationSubmitHiringManagerReviewComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports: components,
})
export class BatchOperationSubmitHiringManagerReviewModule { }
